// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.call-logs-table-container {
  margin: 2rem 0;
}

/* WCAG 2.1 Reflow: contain the table's horizontal scroll to the table so it
   stays within the card on small screens, with the Add Call Log button (outside
   this wrapper) staying fixed — same pattern as the parties/allegations tables. */
.table-scroll {
  overflow-x: auto;
}

.call-logs-table {
  border-collapse: collapse;
  width: 100%;
  min-width: 600px;
  background: #fff;
}

.call-logs-table th,
.call-logs-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: top;
}

.call-logs-table th {
  background: #f5f5f5;
  font-weight: 600;
}

.call-logs-table td {
  font-size: 1rem;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: #888;
}

.d-flex {
  display: flex;
}

.justify-content-end {
  justify-content: flex-end;
}

.mt-3 {
  margin-top: 1rem;
}

.footer-row td {
  border-top: none;
}

.content-row td {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dispute-resolution/call-logs-list/call-logs-list.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,cAAA;AAEF;;AACA;;kFAAA;AAGA;EACE,gBAAA;AAEF;;AACA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AACA;;EAEE,qBAAA;EACA,gCAAA;EACA,mBAAA;AAEF;;AACA;EACE,mBAAA;EACA,gBAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,mBAAA;AAEF","sourcesContent":[".call-logs-table-container {\r\n  margin: 2rem 0;\r\n}\r\n\r\n/* WCAG 2.1 Reflow: contain the table's horizontal scroll to the table so it\r\n   stays within the card on small screens, with the Add Call Log button (outside\r\n   this wrapper) staying fixed — same pattern as the parties/allegations tables. */\r\n.table-scroll {\r\n  overflow-x: auto;\r\n}\r\n\r\n.call-logs-table {\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n  min-width: 600px;\r\n  background: #fff;\r\n}\r\n\r\n.call-logs-table th,\r\n.call-logs-table td {\r\n  padding: 0.75rem 1rem;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  vertical-align: top;\r\n}\r\n\r\n.call-logs-table th {\r\n  background: #f5f5f5;\r\n  font-weight: 600;\r\n}\r\n\r\n.call-logs-table td {\r\n  font-size: 1rem;\r\n}\r\n\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.text-muted {\r\n  color: #888;\r\n}\r\n\r\n.d-flex {\r\n  display: flex;\r\n}\r\n\r\n.justify-content-end {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.mt-3 {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.footer-row td {\r\n  border-top: none;\r\n}\r\n\r\n.content-row td {\r\n  border-bottom: none;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
